import React, { Component } from "react";
import style from "../../faq.module.css";
import { getUrlSegment, sendToUrl } from "../../../../utilities";
// import { postForm, getQA, resetQaData } from "../../actions";
import { Link } from "gatsby";
import ContactForm from "../ContactForm/";
import Breadcrumb from "../../../../components/Breadcrumb";
import NotificationToast from "../../../../components/NotificationToast";
import arrowIcon from "../../../../images/faq-arrow-right.svg";
import arrowIconPink from "../../../../images/faq-arrow-right-pink.svg";
import generalQuestionIcon from "../../../../images/faq-general-question.svg";
import topMFIcon from "../../../../images/faq-top-mutual-funds.svg";
import axios from "axios";
import Layout from "../../../../components/Layout/Layout";
export class QAPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      qaData: {},
      toastMessage: "",
      toastType: "",
      isToastVisible: false
    };

    this.closeModal = this.closeModal.bind(this);
    this.showModal = this.showModal.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchAnswer();
  }

  fetchAnswer = async () => {
    const { question } = this.props.pageContext;
    const result = await axios.get(
      `https://www.api.piggy.co.in/v1/faq/?url_name=${question}`
    );

    this.setState({
      qaData: result.data.data
    });
  };

  showModal() {
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  postForm = async data => {
    const requestURL = `https://www.api.piggy.co.in/piggy/contactus/`;
    const { email, subject, content } = data;
    const name = "Web User FaqPage";
    const body = {
      name,
      email,
      subject,
      content
    };

    const result = await axios.post(requestURL, body);
    if (result.data["status-code"] === 1) {
      this.closeModal();
      this.setState({
        toastMessage: result.data["status-message"],
        toastType: "S",
        isToastVisible: true
      });
    } else
      this.setState({
        toastMessage: result.data["status-message"],
        toastType: "E",
        isToastVisible: true
      });
  };

  render() {
    const data = {};
    if (this.state.qaData && this.state.qaData.faq) {
      const {
        question,
        answer,
        faq_category,
        tab_category,
        url_name
      } = this.state.qaData.faq;
      let label, url, icon, subCategoryUrl;

      if (faq_category === "General") {
        label = "General Questions";
        url = `/faq-category/general-questions`;

        if (tab_category === "Piggy") {
          subCategoryUrl = `/faq-category/${getUrlSegment(
            "about-piggy"
          )}/#${getUrlSegment(tab_category)}`;
        } else {
          subCategoryUrl = `/faq-category/${getUrlSegment(
            "general-questions"
          )}/#${getUrlSegment(tab_category)}`;
        }
        icon = generalQuestionIcon;
      } else {
        label = "Top Mutual funds";
        url = `/faq-category/top-mutual-funds`;
        subCategoryUrl = `/faq-category/${getUrlSegment(
          faq_category
        )}/#${getUrlSegment(tab_category)}`;
        icon = topMFIcon;
      }

      data.question = question;
      data.answer = answer;
      data.breadCrumData = [
        { label: "FAQ", url: sendToUrl("/faq"), icon: null, backIcon: null },
        { label, url: sendToUrl(url), icon, backIcon: arrowIcon },
        {
          label: tab_category,
          url: sendToUrl(subCategoryUrl),
          icon: null,
          backIcon: arrowIcon
        },
        {
          label: `${
            question.length > 30 ? question.substring(0, 30) + "..." : question
          }`,
          url: "",
          icon: null,
          backIcon: arrowIcon,
          isUrl: false
        }
      ];
    }

    if (this.state.qaData && this.state.qaData.related_faqs) {
      data.relatesArticlesData = this.state.qaData.related_faqs.map(item => {
        return {
          question: item.question,
          url: sendToUrl(`/help/${item.url_name}/`)
        };
      });
    }

    return (
      <Layout>
        <div className={style.qaPageContainer}>
          {this.state.showModal ? (
            <ContactForm
              onOutsideClick={() => this.closeModal()}
              postForm={formData => this.postForm(formData)}
            />
          ) : null}

          {this.state.isToastVisible && (
            <NotificationToast
              type={this.state.toastType}
              text={this.state.toastMessage}
            />
          )}
          {data && data.breadCrumData ? (
            <div style={{ width: "100%", margin: "2em 0" }}>
              <Breadcrumb data={data.breadCrumData} />
            </div>
          ) : null}

          <div className={style.hr} />

          <div className={style.qaSection}>
            <div className={style.qa}>
              {data && data.question && data.answer ? (
                <div style={{ width: "100%" }}>
                  <p className={style.title} style={{ textAlign: "left" }}>
                    {data.question}
                  </p>
                  <p
                    className={style.subTitle}
                    style={{ textAlign: "left" }}
                    lineheight={"30px"}
                  >
                    {data.answer}
                  </p>
                </div>
              ) : null}
            </div>
            <div className={style.hrContainer}>
              <div className={style.hr} />
            </div>
            <div className={style.contactContainer}>
              <p className={style.title}>You still have a question</p>
              <p className={style.subTitle} lineheight={"26px"}>
                If you cannot find answer to your question in our FAQ, you can
                always submit a request. We will answer to you shortly!
              </p>
              <button
                className={style.contactButton}
                onClick={() => this.showModal()}
              >
                Submit Request
              </button>
            </div>

            {data && data.relatesArticlesData ? (
              <div className={style.relatedArticlesContainer}>
                <div style={{ width: "100%" }}>
                  <p className={style.listItemTitle}>Related Articles</p>
                  {data.relatesArticlesData.slice(0, 5).map(item => (
                    <div className={style.listItem}>
                      <img className={style.listItemImg} src={arrowIconPink} />
                      <Link to={item.url}>
                        <p className={style.listItemText}>{item.question}</p>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </Layout>
    );
  }
}

export default QAPage;
